module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_7042.96a197dc.png";